export const maskEmail = (email: string): string => {
  const [localPart, domainPart] = email.split('@');
  if (localPart.length <= 4) return email;
  const firstTwoLetters = localPart.slice(0, 2);
  const lastTwoLetters = localPart.slice(-2);
  const maskedLocalPart = '*'.repeat(localPart.length - 4);

  return `${firstTwoLetters}${maskedLocalPart}${lastTwoLetters}@${domainPart}`;
};
